<template lang="pug">
.popup.popup--migrate-verified-articles
  .popup-overlay(@click="closePopup")
  .popup-body.popup-body--offering
    .popup-content
      .popup-questionText
        span.popup-questionText(
          :class="`${isInputArticleId ? 'popup-questionText--narrowPadding' : ''}`"
        ) {{text}}

      .popup-item.popup-item--wrapColumn.popup-item--single(
        v-if='isInputArticleId'
      )
        input.popup-input(
          v-imask="imask"
          placeholder="請輸入連動的文章編號"
          :value='newArticleId'
          @keyup='checkNewArticleID'
          @accept="onAccept"
        )

    PopupButtonsOnBottom.popup-bottom--twoButtons(
      :isActive="isConfirmedButtonActive"
      :isScrollablePopup='false'
      :isSingleButton='false'
      @send="send"
      @cancel="closePopup"
    )

</template>
<script>
import { IMaskDirective } from 'vue-imask';
import PopupButtonsOnBottom from '@/components/popup/popup-buttons-on-bottom.vue';
import { lockBody, unlockBody } from '@/plugins/tool.js';

export default {
  name: 'PopupMigrateVerifiedArticles',
  components: {
    PopupButtonsOnBottom
  },
  directives: {
    imask: IMaskDirective
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    isInputArticleId: {
      type: Boolean,
      default: false
    },
    currentArticleId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      newArticleId: '',
      isConfirmedButtonActive: true,
      imask: {
        mask: '0000000000',
        lazy: true
      },
      onAccept: e => {
        const maskRef = e.detail;
        this.newArticleId = maskRef.value;
      }
    };
  },
  created() {
    this.newArticleId = this.currentArticleId;
    this.checkNewArticleID();
  },
  mounted() {
    lockBody();
  },
  methods: {
    closePopup() {
      unlockBody();
      this.$emit('closePopup');
    },
    send() {
      this.$emit('send', this.newArticleId);
      this.closePopup();
    },
    checkNewArticleID() {
      if (this.newArticleId) {
        this.isConfirmedButtonActive = true;
      } else {
        this.isConfirmedButtonActive = false;
      }
    }
  }
};
</script>
<style src="./popup_migrate_verified_articles.vue.css"></style>
